import { createBrowserHistory, Listener, Action, Location } from 'history';
import ReactGA4 from 'react-ga4';

export const history = createBrowserHistory();

const historyListener: Listener = ({ location }) => {
	ReactGA4.send({ hitType: 'pageview', page: location.pathname });
};
history.listen(historyListener);
historyListener({ location: window.location as unknown as Location, action: Action.Push });
